import React, { FC } from "react";
import { Box, Switch } from "common/components/ui";
import { useIntl } from "react-intl";
import { transfersShipmentCreateLabels } from "transfers/create/transfersShipmentCreate.labels";

interface EachPickingToogleProps {
  isEachPickingOrder: boolean;
  isDisabled?: boolean;
  handleToggle: () => void;
}

export const EachPickingToggle: FC<EachPickingToogleProps> = ({ isEachPickingOrder, isDisabled, handleToggle }) => {
  const { formatMessage } = useIntl();

  return (
    <Box paddingTop={"S2"} paddingBottom={"S2"}>
      <Switch
        checked={isEachPickingOrder}
        onChange={handleToggle}
        disabled={isDisabled}
        label={formatMessage(
          isEachPickingOrder
            ? transfersShipmentCreateLabels.steps.productQuantity.eachPicking.enabled
            : transfersShipmentCreateLabels.steps.productQuantity.eachPicking.disabled
        )}
      />
    </Box>
  );
};
